import { Result, Button } from "antd";
import PageLoading from "components/base/PageLoading";
import { useUserInfo } from "pages/Account/pages/MyProfile/hooks";
import { useCurrentUser } from "components/CurrentUser/hooks";
import React, { Suspense } from "react";
import { useHistory, useLocation } from "react-router";
import PrivateLayout from "./PrivateLayout";
import { useTranslation } from "react-i18next";
import { isBSP, isMicroApp } from "utils/microApp";

interface Props {
  route?: any;
}

const PrivateLayoutContainer: React.FC<Props> = (props) => {
  const { route } = props;

  // useAuth();

  const enableAuth = isMicroApp ? isBSP : true;

  const [user, loading, error, mutate] = useCurrentUser({
    revalidateOnMount: enableAuth,
    revalidateOnFocus: enableAuth,
    revalidateOnReconnect: enableAuth,
    refreshWhenHidden: false,
  });

  const { goBack } = useHistory();

  const {
    loading: loadingInfo,
    error: errorInfo,
    mutate: mutateInfo,
  } = useUserInfo({
    revalidateOnMount: enableAuth,
    revalidateOnFocus: enableAuth,
    revalidateOnReconnect: enableAuth,
  });

  const { t } = useTranslation();

  if (isMicroApp && !isBSP) {
    return <PrivateLayout route={route} />;
  }

  if (loading || loadingInfo) return <PageLoading loading={true} />;

  if (!(loading || loadingInfo) && !!(error || errorInfo)) {
    return (
      <Result
        status={error?.status || errorInfo?.status}
        title={error?.status || errorInfo?.status || "Error"}
        subTitle={
          error?.error ||
          error?.message ||
          errorInfo?.error ||
          errorInfo?.message ||
          t("common.errors.msg")
        }
        extra={[
          <Button
            loading={loading}
            disabled={loading}
            type="primary"
            onClick={() => {
              mutate();
              mutateInfo();
            }}
            key="try_again"
          >
            {t("common.retry")}
          </Button>,
          <Button onClick={goBack} key="go_back">
            {t("common.back")}
          </Button>,
        ]}
      />
    );
  }

  return <PrivateLayout route={route} />;
};

export default (props: Props) => (
  <Suspense fallback={<PageLoading loading={true} />}>
    <PrivateLayoutContainer {...props} />
  </Suspense>
);
